/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TargetObjectDto } from '../../models/target-object-dto';

export interface GetGrantTargets$Params {
  searchStr?: string;
  pageNumber?: number;
  count?: number;
  dir?: 'ASC' | 'DESC';
}

export function getGrantTargets(http: HttpClient, rootUrl: string, params?: GetGrantTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<TargetObjectDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, getGrantTargets.PATH, 'get');
  if (params) {
    rb.query('searchStr', params.searchStr, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('count', params.count, {});
    rb.query('dir', params.dir, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      [key: string]: Array<TargetObjectDto>;
      }>;
    })
  );
}

getGrantTargets.PATH = '/api/users/grant-targets';
